import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Region";

export const REGION_PREFIX_URL = PREFIX_URL;
export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const Create = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const GetById = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Details = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Details`, options);

export const Update = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const Delete = (options) => GENERATE_URL(`${PREFIX_URL}/:id`, options);

export const GetLocations = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/Locations`, options);

export const UpdateLocations = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:id/Locations`, options);

export const WithLocations = (options) =>
  GENERATE_URL(`${PREFIX_URL}/WithLocations`, options);

export default {
  GetAll,
  Create,
  GetById,
  Details,
  Update,
  Delete,
  GetLocations,
  UpdateLocations,
  WithLocations,
};
